export default __webpack_public_path__ + "static/media/ballyhacbg.90412c7e.webp";